<script setup lang="ts">
useHead({
  titleTemplate: '[Admin] %s | Pandaahh Riven',
  title: 'Riven Bot',
  htmlAttrs: {
    class: 'dark'
  },
  link: [
    { rel: 'icon', type: 'image/x-icon', href: '/favicon-admin.ico' }
  ]
})
</script>

<template>
  <UApp>
    <div class="relative bg-background text-toned font-body transition-colors duration-300 flex flex-col selection:bg-primary selection:text-[#0E1729] overflow-x-clip w-full min-h-screen">
      <!-- Global Background matching Warframe & Pandaahh theme -->
      <div class="fixed inset-0 z-[-1] pointer-events-none">
        <div class="absolute inset-0 bg-[url('/background.webp')] bg-cover bg-center bg-no-repeat opacity-20 mix-blend-overlay"></div>
        <div class="absolute inset-0 bg-linear-to-b from-background via-background/90 to-background"></div>
        <div class="absolute inset-0 bg-[radial-gradient(ellipse_at_top,var(--tw-gradient-stops))] bg-muted/80 dark:bg-inherit from-muted/20 via-transparent to-transparent opacity-60"></div>
      </div>

      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
  </UApp>
</template>
